<template>
<div>
  <a class="bigLogo" href="https://hossa.gda.pl">
    <svg class="icon icon-hossa_logo">
      <use xlink:href="#icon-hossa_logo"></use>
    </svg>
  </a>
  <p>GRUPA INWESTYCYJNA HOSSA SA</p>
  <br />
  <p>
    ul. Władysława IV 43, 81-395 Gdynia <br />
    Tel. 58 620 70 33 <br />
    fax 58 620 76 69 <br />
    e-mail: info@hossa.gda.pl <br />
    <br />
  </p>

  <p>
    Sąd Rejonowy Gdańsk-Północ w Gdańsku, VIII Wydział Gospodarczy Krajowego
    Rejestru Sądowego; Rejestr Przedsiębiorców Nr KRS 0000006925; REGON
    190358085; NIP 586-02-20-726; Kapitał własny: 551 000 000 zł*, kapitał
    wpłacony: 2 200 000 zł, kapitał zakładowy: 2 200 000 zł (*stan na dzień 30.06.2020).
  </p>
</div>
</template>

<script>
export default {
  name: "rightBox"
};
</script>
